import styled from 'styled-components';

export const TreeSelectWrapper = styled.div`
  position: absolute;
  background: white;
  width: 100%;
  border: 1px solid #ddd;
  top: 36px;
  left: 0;
  display: ${props => (props.isOpenSelect ? 'block' : 'none')};
  z-index: 100;
  max-height: 300px;
  overflow-y: scroll;
`;

export const TreeUnorderedList = styled.ul`
  margin: 0;
  padding: 10px;
  padding-left: ${props => (props.hasChild ? '20px' : '10px')};
  & > svg {
    margin-right: 5px;
    transition: all 300ms ease-in-out;
    transform: rotateZ(${props => (props.isSelected ? '0deg' : '-90deg')});
  }
`;

export const TreeListItem = styled.li`
  display: block;
  padding: 10px 10px 10px 25px;
  background: ${props => (props.isActive ? '#f6faff' : 'white')};
  cursor: ${props => props.disabled && 'not-allowed'};
  color: ${props => (props.disabled ? '#ddd' : '#333')};
  &:hover {
    background: ${props => (props.disabled ? 'white' : '#eef5ff')};
  }
`;

export const PullDownIconSection = styled.div`
  width: 37px;
  height: 36px;
  background: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0 2px 2px 0;
  color: white;

  & > svg {
    transform: rotateZ(${props => (props.active ? '180deg' : '0deg')});
  }
`;

export const TreeSelectContainer = styled.div`
  border: 1px solid #ccc;
  padding: 8px 10px;
  height: 38px;
  cursor: ${props => !props.disabled && 'pointer'};
  position: relative;
  border-radius: 3px;
  color: #333;
  font-size: 14px;
  box-shadow: none;
  background: ${props => (props.disabled ? '#f9f9f9' : '#fff')};
  text-align: left;
  margin-bottom: 16px;
  width: 100%;
  & > span.tree-select-placeholder {
    color: #ddd;
  }
`;
